import { const_var } from "../../redux/reducers/common/stateObjects";
import { getBuildingPricingData } from "../../helpers/building_pricing/buildingPricing.helper";
import { applicableWainscot } from "../../helpers/building/building_color/wainscotColor.helper";
import { checkLegsDataAccordingtoResponse } from "../../helpers/building_component/legs_condition.helper";
import { setZeroPriceOverhang } from "../../helpers/extra_options_pricing/overhangPricing";

export const setPricingData = (apiResponse, newFlag) => {
	if (newFlag != undefined) {
		if (newFlag == "w" || newFlag == "l") {
			const_var.UpdatedPriceData.roof_style_price_changed = true;
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.truss_price_changed = true;
		}
		if (newFlag == "h") {
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.truss_price_changed = true;
		}
	}
	return {
		type: "SETPRICINGDATA",
		value: apiResponse,
		str: newFlag
	};
};

export function updatePriceCalculation(newVal, oldVal, key, leanVal, leanIndex, uniqueId, elementObjIndex, extraItemType, cupolaId, anchor) {
	newVal = newVal.replace(/,/g, "");
	return {
		type: "updatePriceCalculation",
		newVal: newVal,
		oldVal: oldVal,
		key: key,
		leanVal: leanVal,
		objIndex: leanIndex,
		uniqueId: uniqueId,
		elementObjIndex: elementObjIndex,
		extraItemType: extraItemType,
		cupolaId: cupolaId,
		anchor: anchor
	};
}

export const createGetPricingData = (deps, actions) => {
	const { params, const_var, utils, setPricingData, resetCheckBoxQuantityExtraBowsPrice } = deps;
	const { getPricingDataForLeanto } = actions;

	function getPricingData(flag, leanVal, newStr, forLeanRoofReset, makePricingZero) {
		params.apiCallAfterEdit = false;
		const_var.is_loader = false;
		let Mainval = 0;
		if (params.p_b_t == "2") {
			Mainval = params.p_r_s == 4 || params.p_r_s == 5 ? params.p_h - 5 : params.p_h - 3;
		} else {
			Mainval = 0;
		}
		const_var.CallApionAction = true;
		const_var.isPriceAPIcalled = true;
		const_var.onDragUtilityPriceUpdateLeft = false;
		const_var.onDragUtilityPriceUpdateRight = false;
		const_var.onDragUtilityPriceUpdateFront = false;
		const_var.onDragUtilityPriceUpdateBack = false;
		const_var.onDragUtilityPriceUpdateCenterBuilding = false;
		const_var.isWainscotManualPriceUpdate = false;

		let apiData = "";
		let exactCalculation = 0;
		let incloseVal = 0;
		if (params.cB_addStorage_check_left == true) {
			incloseVal = params.cB_addStorage_left;
		}
		if (params.cB_addStorage_check_right == true) {
			incloseVal = params.cB_addStorage_right;
		}
		if (parseInt(incloseVal) > params.p_w / 2) {
			exactCalculation = parseInt(params.p_h + Math.ceil((params.p_r_p * (params.p_w / 2)) / 12));
		} else {
			exactCalculation = parseInt(params.p_h + Math.ceil((params.p_r_p / (params.p_w / 2)) * incloseVal));
		}
		if (exactCalculation > const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value) {
			exactCalculation = const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
		}

		if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
			let chkFixedWidth = false;
			chkFixedWidth = const_var.c_m_a[params.p_b_t] ? (const_var.c_m_a[params.p_b_t].fixed_new_leg_width ? (const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0 ? true : false) : false) : false;
			if (incloseVal != 0) {
				if (parseInt(incloseVal) > params.p_w / 2) {
					exactCalculation = parseInt(Math.round(params.p_h - params.p_r_p) + Math.ceil((params.p_r_p / params.p_w) * incloseVal));
				} else {
					exactCalculation = parseInt(Math.round(params.p_h - params.p_r_p) + Math.ceil((params.p_r_p / params.p_w) * incloseVal));
				}
				if (exactCalculation > const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value) {
					exactCalculation = const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
				}

				apiData = {
					width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
					height: params.p_h,
					single_slope_height:
						const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
							? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
							: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
					length: params.p_d,
					map_id: const_var.Map_Id[params.p_b_t],
					roof_id: params.p_r_s,
					lean_to_height: 0,
					utility_length: params.p_u_c == true ? params.p_u_t : 0,
					utility_width: parseInt(incloseVal),
					pitch_height: exactCalculation,
					is_smaller_frame_width: chkFixedWidth
				};
			} else {
				apiData = {
					width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
					height: params.p_h,
					single_slope_height:
						const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
							? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
							: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
					length: params.p_d,
					map_id: const_var.Map_Id[params.p_b_t],
					roof_id: params.p_r_s,
					lean_to_height: 0,
					utility_length: params.p_u_c == true ? params.p_u_t : 0,
					is_smaller_frame_width: chkFixedWidth
				};
			}
		} else {
			if (incloseVal != 0) {
				apiData = {
					width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
					height: params.p_h,
					length: params.p_d,
					map_id: const_var.Map_Id[params.p_b_t],
					roof_id: params.p_r_s,
					lean_to_height: Mainval,
					utility_length: params.p_u_c == true ? params.p_u_t : 0,
					utility_width: parseInt(incloseVal),
					pitch_height: exactCalculation
				};
			} else {
				apiData = {
					width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
					height: params.p_h,
					length: params.p_d,
					map_id: const_var.Map_Id[params.p_b_t],
					roof_id: params.p_r_s,
					lean_to_height: Mainval,
					utility_length: params.p_u_c == true ? Math.round(params.p_u_t) : 0,
					front_utility_length: params.cB_addStorage_check_front ? Math.round(params.cB_addStorage_front) : 0
				};
			}
		}
		const_var.UpdatedPriceData.connection_fee_side_changed = true;
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		if (params.p_j_t == true) {
			const_var.UpdatedPriceData.common_length_changed = true;
			const_var.UpdatedPriceData.common_left_lean_length_changed = true;
			const_var.UpdatedPriceData.common_right_lean_length_changed = true;
			const_var.UpdatedPriceData.common_front_lean_length_changed = true;
			const_var.UpdatedPriceData.common_back_lean_length_changed = true;
		}
		if (params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true || params.noStorageCertificatePriceChange) {
			const_var.UpdatedPriceData.utility_price_changed = true;
			const_var.UpdatedPriceData.front_utility_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
			if (params.noStorageCertificatePriceChange) params.noStorageCertificatePriceChange = false;
		}
		resetCheckBoxQuantityExtraBowsPrice();

		if (apiData != undefined) {
			apiData.gauge = const_var.g_v;
		}
		if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
			apiData.is_lean_to_price = true;
		}
		if (params.p_r_p != undefined) {
			apiData.pitch_type = `${params.p_r_p}_12`;
		}
		if (const_var.selSidingObj && const_var.selSidingObj.name != "metal" && const_var.selSidingObj.price_type != "%") {
			if (const_var.selSidingObj.name == const_var.selSidingOption) {
				apiData.side_end_name = const_var.selSidingObj.name;
			}
		}
		if (params.m_s_n == 122 && const_var.selSidingObj && const_var.selSidingObj.name?.includes("board_and_batten")) {
			apiData.send_default_data = true;
		}
		let checkDollarExist = const_var.c_m_a?.[const_var.post_data.building.building_type]?.wainscot_details?.find((wain) => wain?.name && params.wainscotTexture?.includes(wain?.name));
		if (params.p_w_c_n && checkDollarExist?.price_type == "$" && params.wainscotTexture != "metal") {
			apiData.applicable_wainscot = applicableWainscot();
		}
		return async (dispatch) => {

			   const {response,componentResponse} = await getBuildingPricingData(apiData);
                const_var.componentData = componentResponse.data; 

			if (params.m_s_n == 122 && const_var.selSidingObj && const_var.selSidingObj.name?.includes("board_and_batten") && response?.data?.data) {
				setZeroPriceOverhang(response.data.data);
			}
			if (apiData.utility_length == undefined || (apiData.utility_length && apiData.utility_length == 0)) {
				if (Array.isArray(const_var?.leanGetDataBack?.connection_fees)) {
					const_var.leanGetDataBack.connection_fees = [];
				}
				if (Array.isArray(const_var?.leanGetDataFront?.connection_fees)) {
					const_var.leanGetDataFront.connection_fees = [];
				}
				if (Array.isArray(const_var?.leanGetDataRight?.connection_fees)) {
					const_var.leanGetDataRight.connection_fees = [];
				}
				if (Array.isArray(const_var?.leanGetDataLeft?.connection_fees)) {
					const_var.leanGetDataLeft.connection_fees = [];
				}
			}
			const_var.isUpdate4ftLegLogic = /* true */ params.m_s_n == 3 ? true : false;
			const_var.engineer_drawings_price_changed = true;
			const_var.installationsurfaceChange = true;
			const_var.is_edit_labour = undefined;

			if (const_var.stateData?.fetch_price_for?.surcharge && const_var.surcharge_amount_is_edit != true) {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
			}
			const_var.UpdatedPriceData.discount_rate_updated = undefined; //----SE3-I5692->if user manually update base price to 0, then under klink on updating the dimensions, discount isn't getting applied, if it's calculating on base price--------//
			if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
				const_var.isCheckGroundCertificate = true;
			}

			if (params.p_i_o != 0) {
				if (const_var.UpdatedPriceData.insulation_price_changed == undefined && const_var.UpdatedPriceData.insulation_price != undefined && const_var.isInsulationPriceManualChange) {
				} else {
					const_var.UpdatedPriceData.insulation_price = undefined;
					const_var.UpdatedPriceData.insulation_price_changed = true;
				}
				if (response.data.data != undefined && response.data.data.insulation != undefined && const_var.isInsulaltionForOldQuotes == false && const_var.crmSetting.is_Edit == true) {
					if (response.data.data.insulation.length > 0 && response.data.data.insulation.filter((obj) => obj.insulation_id == params.p_i_o).length == 0) {
						params.p_i_o = response.data.data.insulation[0].insulation_id; //0
						params.selectedInsulationId = response.data.data.insulation[0].insulation_id;

						params.insulation.center.isCheked = false;
						params.insulation.center.insulationId = 0;
						params.insulation.center.roofOnly = false;
						params.insulation.center.fullBuilding = false;
						params.insulation.center.custom = false;
						params.insulation.center.showInsulationOptions = false;
						params.insulation.center.isDisableFullInsulation = false;

						params.insulation.center.showInsulation = true;
						const_var.insulationJson = [];

						for (var i = 0; i < response.data.data.insulation.length; i++) {
							const_var.insulationJson[response.data.data.insulation[i].insulation_id] = response.data.data.insulation[i].name;
							const_var.insulationPriceJson[response.data.data.insulation[i].insulation_id] = response.data.data.insulation[i];
						}
						const_var.InsulationObj = response.data.data.insulation || [];
					}

					if (response.data.data.insulation.length == 0) {
						params.p_i_o = 0;
						params.insulation.center.showInsulation = false;
						const_var.insulationJson = [];
						const_var.InsulationObj = [];
						const_var.insulationPriceJson = [];
					}
				} else {
					if (const_var.isInsulationPriceManualChange) {
						const_var.isInsulationPriceManualChange = false;
					} else {
						const_var.UpdatedPriceData.height_price_changed = true;
						const_var.UpdatedPriceData.roof_style_price_changed = true;
						const_var.UpdatedPriceData.bothLeanto = true;
					}
				}
			}
			if (newStr == "roofstyle" && const_var?.c_m_a[params?.p_b_t].roof_style.find((rs) => rs.roof_id == params?.p_r_s)?.conditions?.["condition"]) {
				const_var.ConditionArr[params.p_b_t][params.p_r_s] = const_var?.c_m_a[params?.p_b_t].roof_style.find((rs) => rs.roof_id == params?.p_r_s)?.conditions?.["condition"];
			}
			if (newStr == "w" || newStr == "l") {
				checkLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "dimension");
			}
			if (newStr == "h") {
				const_var.ConditionArr[params.p_b_t][params.p_r_s] = response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"];
				checkLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "dimension");
			}
			if (newStr == "w" && const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
				if (response.data.data.building_structure[0].fixed_width != undefined && response.data.data.building_structure[0].fixed_width.split(",").length > 0) {
					const_var.ConditionArr[params.p_b_t][params.p_r_s] = response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"];
					const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray = [];
					let countWidth = const_var.ConditionArr[params.p_b_t][params.p_r_s].filter((data) => (data.min_width != "" || data.min_width != null) && data.min_width <= params.p_w && data.max_width >= params.p_w);
					let countHeight = const_var.ConditionArr[params.p_b_t][params.p_r_s].filter(
						(data) => (data.min_height != "" || data.min_height != null) && data.min_height <= params.p_h && data.max_height >= params.p_h
					);
					const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray = countHeight.length > 0 ? countHeight : countWidth;
				}
				checkLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "dimension");
			}
			if (params.p_w_c_n == true) {
				const_var.UpdatedPriceData.wainscot_price_changed = true;
			}
			if (flag == undefined) {
				if (newStr == "w" || newStr == "l" || newStr == "h") {
					const_var.UpdatedPriceData.right_wall_price_changed = true;
					const_var.UpdatedPriceData.left_wall_price_changed = true;
					const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
					const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
					const_var.UpdatedPriceData.front_wall_price_changed = true;
					const_var.UpdatedPriceData.back_wall_price_changed = true;
					const_var.UpdatedPriceData.connection_fee_end_changed = true;
				}
			}
			if (const_var.diffHeight != "") {
				if (params.p_h != const_var.diffHeight && newStr == "h" && const_var.UpdatedPriceData.lifttype_price_changed != false) {
					const_var.UpdatedPriceData.lifttype_price_changed = false;
				}
			}
			const_var.UpdatedPriceData.roof_style_price_changed = true;
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.holdPricingResponse = response.data?.data;

			utils.prepareLoftDropdown();
			// utils.handleSelectionIndexingForExtraAddOn(response.data?.data);
			// utils.handleSelectionIndexingForAdditionFeature(response.data?.data);
			// utils.checkForExtraAddOnCheckedoption();
			dispatch(setPricingData(response.data, newStr));
			if (params.isBreezeway && params.cB_addStorage_check_front && params.p_u_c) {
				const_var.UpdatedPriceData.utility_price_changed = true;
				const_var.UpdatedPriceData.front_utility_price_changed = true;
				const_var.UpdatedPriceData.wainscot_price_changed = true;

				const_var.UpdatedPriceData.roof_color_price_changed = true;
				const_var.UpdatedPriceData.wall_color_price_changed = true;
				const_var.UpdatedPriceData.trim_color_price_changed = true;
				const_var.UpdatedPriceData.roof_pitch_price_changed = true;
				const_var.UpdatedPriceData.connection_fee_end_changed = true;
				const_var.UpdatedPriceData.roof_style_price_changed = true;
			}

			if (flag == undefined) {
				const_var.UpdatedPriceData.roof_style_price_changed = true;
				const_var.UpdatedPriceData.height_price_changed = true;
				const_var.UpdatedPriceData.roof_pitch_price_changed = true;

				if (params.add_front_lean == true) {
					if (params.add_left_front_lean_porch == true || params.add_right_front_lean_porch == true) {
						dispatch(getPricingDataForLeanto(leanVal, "addFrontLean", params.lean_p_w, false, "checkLegs", forLeanRoofReset));
					} else {
						dispatch(getPricingDataForLeanto(true, "addFrontLean", "", undefined, "checkLegs", undefined, forLeanRoofReset));
					}
				}
				if (params.add_left_lean == true) {
					if (params.add_left_front_lean_porch == true || params.add_left_back_lean_porch == true) {
						dispatch(getPricingDataForLeanto(leanVal, "addLeftLean", params.leanF_p_w, false, "checkLegs", forLeanRoofReset));
					} else {
						dispatch(getPricingDataForLeanto(true, "addLeftLean", "", undefined, "checkLegs", undefined, forLeanRoofReset));
					}
				}
				if (params.add_right_lean == true) {
					if (params.add_right_front_lean_porch == true || params.add_right_back_lean_porch == true) {
						dispatch(getPricingDataForLeanto(leanVal, "addRightLean", params.leanF_p_w, false, "checkLegs", forLeanRoofReset));
					} else {
						dispatch(getPricingDataForLeanto(true, "addRightLean", "", undefined, "checkLegs", undefined, "forLeanRoofReset"));
					}
				}
				if (params.add_back_lean == true) {
					if (params.add_left_back_lean_porch == true || params.add_right_back_lean_porch == true) {
						dispatch(getPricingDataForLeanto(leanVal, "addBackLean", params.lean_p_w, false, "checkLegs", forLeanRoofReset));
					} else {
						dispatch(getPricingDataForLeanto(true, "addBackLean", "", undefined, "checkLegs", undefined, forLeanRoofReset));
					}
				}
			}
		};
	}

	return getPricingData;
};
